import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UserRoleEnum } from '../../../backend/model/userRoleEnum';
import { AuthService } from '../../services/auth.service';
import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

export class BaseComponent {
  isAdmin = false;
  isUser = false;
  isSysAdmin = false;

  constructor(
    authService: AuthService,
    private translateService: TranslateService,
    private msgService: NzMessageService
  ) {
    const role = authService.getUserRole();

    this.isAdmin = role === UserRoleEnum.Administrator;
    this.isSysAdmin = role === UserRoleEnum.SystemAdministrator;
    this.isUser = role == UserRoleEnum.User;
  }

  errorHandler(response: HttpErrorResponse, form?: UntypedFormGroup) {
    this.msgService.remove();

    if (response.status === 500) {
      this.msgService.error('Oops, something is not right.');
      return;
    }

    if (response.error) {
      const errorMessage = response.error.message;

      if (errorMessage) {
        this.msgService.error(
          this.translateService.instant('exception.' + errorMessage)
        );
        3;
      }
    }

    if (form && response.error.errors) {
      const responseErrors = response.error.errors;

      Object.keys(responseErrors).forEach((i) => {
        const formError = responseErrors[i];
        let formControl = form.controls[formError?.field?.toCamelCase()];

        if (!formControl) {
          formControl = form.controls[i.toCamelCase()];
        }

        if (!formControl) {
          formControl = form.controls[formError?.field?.toLowerCase()];
        }

        const errors: ValidationErrors = {};
        if (formError.error === 'Required') {
          errors.required = true;
        } else if (formError.error === 'PhoneNumberFormatInvalid') {
          errors.phoneNumberFormatInvalid = true;
        } else if (formError.error === 'NotValidEmailAddress') {
          errors.email = true;
        } else if (formError.error === 'EmailInUse') {
          errors.emailInUse = true;
        } else if (formError.error === 'MinLength') {
          errors.minLength = true;
        } else if (formError.error === 'ExactLength') {
          errors.exactLength = true;
        } else if (formError.error === 'Regex') {
          errors.regex = true;
        } else {
          errors.unknown = true;
        }

        if (formControl) {
          formControl.markAsTouched();
          formControl.markAsDirty();
          formControl.setErrors(errors);
        }
      });
    }
  }
}
